import type { ScheduleDay } from "../types/hackathon";

// Each day has three blocks: morning, lunch (12:00–13:30) and afternoon/evening.
export const schedule: ScheduleDay[] = [
  {
    day: 1,
    theme: "Kickoff",
    goal: "Problem, customer and plan per pair",
    videoPrompt: "Introduce your pair, your track and the problem and customer you're going after.",
    sessions: [
      { time: "AM", title: "09:00 breakfast; welcome, rules, introductions; tracks and briefs assigned to pairs" },
      { time: "Lunch", title: "Welcome lunch" },
      { time: "PM", title: "AI tool and hardware kit setup; 17:30 first pitch to mentors; dinner" },
    ],
  },
  {
    day: 2,
    theme: "Build",
    goal: "First customer interviews",
    videoPrompt: "Share what you heard in your first customer interviews.",
    sessions: [
      { time: "AM", title: "Build" },
      { time: "Lunch", title: "Lunch speaker (TBA)" },
      { time: "PM", title: "Build + mentor office hours; 18:00–20:00 masterclass with Kashyap Kompella (TPH Ventures)" },
    ],
  },
  {
    day: 3,
    theme: "Build",
    goal: "First working prototype",
    videoPrompt: "Show your first working prototype — what works and what doesn't yet.",
    sessions: [
      { time: "AM", title: "Build" },
      { time: "Lunch", title: "Lunch speaker (TBA)" },
      { time: "PM", title: "Build + mentor office hours" },
    ],
  },
  {
    day: 4,
    theme: "Build",
    goal: "Field or user test",
    videoPrompt: "Show your field or user test and what you learned from it.",
    sessions: [
      { time: "AM", title: "Build" },
      { time: "Lunch", title: "Lunch" },
      { time: "PM", title: "Build + mentor office hours" },
    ],
  },
  {
    day: 5,
    theme: "Build",
    goal: "Cost model and user evidence",
    videoPrompt: "Walk through your cost model and the user evidence behind your product.",
    sessions: [
      { time: "AM", title: "Build" },
      { time: "Lunch", title: "Lunch" },
      { time: "PM", title: "Build + mentor office hours; mid-week check-in with every pair" },
    ],
  },
  {
    day: 6,
    theme: "Freeze",
    goal: "Rehearsed pitch and backup video",
    videoPrompt: "Share your rehearsed pitch — this doubles as your backup demo video.",
    sessions: [
      { time: "AM", title: "Build" },
      { time: "Lunch", title: "Lunch speaker (TBA)" },
      { time: "PM", title: "Hardware and software freeze; mock Demo Day with mentors" },
    ],
  },
  {
    day: 7,
    theme: "Demo Day",
    goal: "Winners announced",
    sessions: [
      { time: "AM", title: "Final prep" },
      { time: "PM", title: "14:00 final pitches; 15:30 judges deliberate; 16:00 results announced and feedback sessions; 16:45 final videos recorded" },
    ],
  },
];
